
import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator'
import {
  Company,
  PriceList,
  PriceListCollection,
  UserCollection
} from '@/firestore'
import AuthMixin from '@/mixins/AuthMixin.vue'
import PhoneNumber from '@/components/PhoneNumber.vue'
import axios from 'axios'

@Component({
  components: {PhoneNumber}
})
export default class EnableVendorModal extends Mixins(AuthMixin) {
  @Prop({type: Boolean, default: false})
  public show!: boolean

  @Prop({type: Object, default: null})
  public vendor!: Company

  @Prop({
    type: Object,
    default: () => ({
      repName: '',
      phoneNumber: '',
      email: ''
    })
  })
  public priceListPayload!: {
    repName: string,
    phoneNumber: string,
    email: string
  }

  @Prop({type: Object, default: null})
  public priceListToChange!: PriceList

  @Prop({type: String, default: ''})
  public action!: string

  public $refs!: {
    form: HTMLFormElement
  }

  public priceList: PriceList | null = null
  public savingVendor = false
  public loadingPhoneNumber = false
  public disabled = true
  public valid: boolean = false

  @Watch('show')
  public async loadVendors() {
  }

  @Watch('priceListPayload.phoneNumber')
  public async lookupPhoneNumber() {
    if (!/^\+\d+[0-9]{3}[0-9]{3}[0-9]{4}$/.test(this.priceListPayload.phoneNumber)) {
      this.disabled = true
      this.priceListPayload.repName = ''
      this.priceListPayload.email = ''
      return
    }

    this.loadingPhoneNumber = true

    const userCollection = new UserCollection((await this.$firebase).firestore())
    const user = await userCollection.getUserByPhone(this.priceListPayload.phoneNumber)

    if (!user) {
      this.priceListPayload.repName = ''
      this.priceListPayload.email = ''
      this.disabled = false
    } else {
      this.priceListPayload.repName = user.name
      this.priceListPayload.email = user.email
    }

    this.loadingPhoneNumber = false
  }

  @Emit()
  public async confirmSave() {
    if (this.$refs.form) {
      this.$refs.form.validate()
    }

    if (this.valid) {
      if (this.action === 'changeRep') {
        await this.changePriceListRep()
      } else {
        await this.enableVendor()
      }

      this.hide()
      this.saved()
    }
  }

  @Emit()
  public hide() {
  }

  @Emit()
  public saved() {
    this.$refs.form.reset()
  }

  private async enableVendor() {
    this.savingVendor = true

    await this.updateVendorEmail()
    await this.updatePriceList()

    this.savingVendor = false
  }

  private async changePriceListRep() {
    this.savingVendor = true

    if (this.priceListToChange) {
      const priceListToChange = {...this.priceListToChange} as PriceList

      const priceListCollection = new PriceListCollection((await this.$firebase).firestore())
      priceListToChange.vendorRepPhoneNumber = this.priceListPayload.phoneNumber.replace(/[\(\)\- ]+/g, '')
      priceListToChange.vendorRepEmail = this.priceListPayload.email
      priceListToChange.vendorRepName = this.priceListPayload.repName
      priceListToChange.active = true

      const response = await axios.post(
          `/api/vendors/${this.vendor.id}/rep`,
          {
            email: priceListToChange.vendorRepEmail,
            phoneNumber: priceListToChange.vendorRepPhoneNumber,
            name: priceListToChange.vendorRepName
          }
      ) as { data: { userId: string, userEmail: string, userPhoneNumber: string } }

      priceListToChange.vendorRepId = response.data.userId

      await priceListCollection.save(priceListToChange)
    }

    this.savingVendor = false
  }

  protected async updateVendorEmail() {
    if (!this.vendor) {
      return
    }

    const priceListCollection = new PriceListCollection((await this.$firebase).firestore())
    this.priceList = await priceListCollection.findPriceListByRestaurantAndVendorAndPhoneNumber(
        this.userCompany.id,
        this.vendor.id,
        this.priceListPayload.phoneNumber.replace(/[\(\)\- ]+/g, '')
    )

    if (!this.priceList || this.priceList.vendorRepPhoneNumber !== this.priceListPayload.phoneNumber) {
      this.priceList = new PriceList(this.vendor.id, this.userCompany.id)
    }

    this.priceList.vendorRepPhoneNumber = this.priceListPayload.phoneNumber.replace(/[\(\)\- ]+/g, '')
    this.priceList.vendorRepEmail = this.priceListPayload.email
    this.priceList.vendorRepName = this.priceListPayload.repName
    this.priceList.vendorCompanyName = this.vendor.name
    this.priceList.active = true

    if (!this.priceList) {
      return
    }

    const response = await axios.post(
        `/api/vendors/${this.vendor.id}/rep`,
        {
          email: this.priceList.vendorRepEmail,
          phoneNumber: this.priceList.vendorRepPhoneNumber,
          name: this.priceListPayload.repName
        }
    ) as { data: { userId: string, userEmail: string, userPhoneNumber: string } }

    this.priceList.vendorRepId = response.data.userId
  }

  public async updatePriceList() {
    if (this.priceList) {
      const priceListCollection = new PriceListCollection((await this.$firebase).firestore())
      await priceListCollection.save({
        ...this.priceList,
        entries: this.priceList.entries.filter(entry => !entry.isBlank)
      } as PriceList)
    }
  }
}
